<template>
    <div class="card shadow-sm mb-5 p-5 card-flush overflow-hidden h-md-100">
      <button v-if="remove"
          type="button"
          class="btn-close position-absolute top-0 end-0 mt-2 me-4"
          aria-label="Remove"
          @click="remove"/>

        <div class="card-header">
        <div class="card-title">
            <h5 style="text-align: start">{{ title }}</h5>
        </div>
       
        </div>
        <Loader :is-loading="loading">
          <div class="card-body d-flex text-center justify-content-center flex-column px-0">
            <div v-show="!saleEstimateStatus?.length" class="text-center">
              <img src="@/assets/media/pos/Empty2.png" alt="" class="mw-100 h-150px" />
              <div class="text-gray-400 fs-4 fw-bold">{{ $t('no_data_found') }}</div>
            </div>
            <div v-show="saleEstimateStatus?.length" class="p-5">
              <canvas id="kt_chartjs_contacts" class="mh-200px"></canvas>
            </div>
          </div>
        </Loader>
    </div>  
</template>
<script setup>
import Loader from '@/components/Loader.vue';
import { computed, watch } from 'vue';
import {  onMounted, ref} from 'vue';
import { useStore } from 'vuex';
import { useLocales } from '@/composables/locales';

const store = useStore()
const { locale } = useLocales()

const props = defineProps({
  id:{type: String, required: true},
  title:{type: String, required: true},
  loading:{type: Boolean, default: false},
  loadStats:{type: Function, required: true},
  remove:{type: Function},
  start: { type: Date, required: false },
  end: { type: Date, required: false },

})
  
const query = ref({
    start_date: '',
    end_date: '',
    opportunity_id: '',
    seller_id: '',
    status: 'WON'
})


const saleEstimateStatus = ref([])
const chartEstimateStatusRef = ref(null)

const estimateStatus = computed(() => store.getters['estimates/estimateStatus'])

watch(() => [props.start, props.end], () => {
 if(props.start) query.value.start_date = props.start
 if(props.end) query.value.end_date = props.end
})

watch(() => query.value, () => {
  if (query.value.start_date && query.value.end_date) {
    loadData();
  }
}, {deep: true})

function loadData(){
  if (!query.value.start_date || !query.value.end_date) {
    console.warn("Dates non définies, loadData ignorée");
    return;
  } 
  
    Promise.all([
        props.loadStats({id:props.id,startDate: query.value.start_date, endDate: query.value.end_date, opportunity_id: query.value.opportunity_id, seller_id: query.value.seller_id, status: query.value.status}).then((res) => {
        
          saleEstimateStatus.value = res.data?.estimateStatusTurnover || res?.response?.estimateStatusTurnover

        }),
        store.dispatch('estimates/loadEstimateStatus'),

    ]).then(() => {
      chartEstimateStatus()
    })
}

function chartEstimateStatus(){
  let names = [];
  let percentages = [];
  let colors = [];

  saleEstimateStatus.value?.forEach(status => {
    let filter = filterStatus(status.name)[0]
    if (status.percentage > 0) { 
      names.push(filter[locale.value])
      percentages.push(status.percentage)
      colors.push(getColor(status.name))
    }
  })

  if(names.length === 0 || percentages.length === 0 || colors.length === 0){
    saleEstimateStatus.value = [];
  }

  let ctx = document.getElementById('kt_chartjs_contacts');

  if (ctx) {
    if(Chart.getChart("kt_chartjs_contacts")) {
      Chart.getChart("kt_chartjs_contacts")?.destroy()
    }
    let context = ctx.getContext('2d');
    let fontFamily = KTUtil.getCssVariableValue('--bs-font-sans-serif');

    let data = {
        labels: names,
        datasets: [{
          data: percentages,
          backgroundColor: colors,
          hoverOffset: 10
      }]
    };

    let config = {
        type: 'doughnut',
        data: data,
        options: {
          plugins: {
              legend: {
                  display: true
              },
              tooltip: {
                  callbacks: {
                      label: function(context) {
                        let percentageLabel = i18n.global.t('crm.statistics.percentage');
                          return `${percentageLabel}: ${$formatLocalAmount(context.parsed)} %`;
                      }
                  }
              }
          },
          responsive: true,
          elements: {
            arc: {
                borderWidth: 1 
            }
          },
          cutout: '80%'
        },
        defaults:{
            global: {
                defaultFont: fontFamily
            }
        }
    };

    if (!chartEstimateStatusRef.value) {
      chartEstimateStatusRef.value = new Chart(ctx, config);
    }else{
      chartEstimateStatusRef.value.destroy()
      chartEstimateStatusRef.value = new Chart(ctx, config);
    }
  } else {
    console.error('Canvas element not found');
    return;
  }
}
  
function filterStatus(value){
  let statistic = estimateStatus.value.filter(status => status.value === value)
  return statistic
}

function getColor(value){
  let color = ''
  switch (value) {
    case 'APPROVED':
      color = '#2DA333';
      break;
    case 'CANCELLED':
      color = '#e4e6ef';
      break;
    case 'PENDING':
      color = '#0072CE';
      break;
    case 'REJECTED':
      color = '#E51335';
      break;
    default:
      color = '#000000';
  }

  return color;
}

onMounted(() => {
  if(props.start) query.value.start_date = props.start
 if(props.end) query.value.end_date = props.end
})
</script>